import { Routes } from '@angular/router';
import { accountRoutes } from './routes/accounts.routes';
import { betaRoutes } from './routes/beta.routes';
import { claimProfileRoutes } from './routes/claim-profile.routes';
import { locationRoutes } from './routes/location.routes';
import { printAssetsRoutes } from './routes/print-assets.routes';
import { profileRoutes } from './routes/profile.routes';
import { propertyReportRoutes } from './routes/property-reports.routes';
import { reviewConversionRoutes } from './routes/review-conversion.routes';
import { writeReviewRoutes } from './routes/write-reviews.routes';

export const routes: Routes = [
  ...betaRoutes,
  {
    path: '',
    loadComponent: () => import('@rma/site/home'),
    pathMatch: 'full',
    data: {
      showMarketingNav: true,
    },
  },
  {
    path: 'sitemap',
    loadChildren: () => import('@rma/site/sitemap'),
    data: {
      title: 'Sitemap',
    },
  },
  {
    path: 'search',
    loadComponent: () => import('@rma/search/nlp-search'),
    data: {
      title: 'Search',
    },
  },
  {
    path: 'blog',
    loadChildren: () => import('@rma/site/blog'),
    data: {
      title: 'Blog',
    },
  },
  {
    path: 'tracked-properties',
    loadChildren: () => import('@rma/campaigns/track-campaign'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/site/static-documents'),
  },
  {
    path: 'mls/licensing',
    loadComponent: () => import('@rma/site/licensing'),
  },

  ...accountRoutes,
  ...claimProfileRoutes,
  ...locationRoutes,
  ...printAssetsRoutes,
  ...profileRoutes,
  ...propertyReportRoutes,
  ...reviewConversionRoutes,
  ...writeReviewRoutes,
  {
    path: '',
    loadChildren: () => import('@rma/generic/fallback-pages'),
  },
];
